<div class="row space-between">
  <form [formGroup]="searchInput">
    <mat-form-field class="search-input">
      <div class="row">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          placeholder="{{ 'UserManagementComponent.searchUsers' | translate }}"
          matInput
          type="text"
          (change)="search()"
          formControlName="searchText"
        />
      </div>
    </mat-form-field>
  </form>
  <button mat-raised-button color="primary" (click)="openReactivateUserDialog()">
    {{ 'UserManagementComponent.reactivateUser' | translate }}
  </button>
  <button mat-raised-button color="primary" [hidden]="!isCurrentUserAdmin" (click)="openInviteUserDialog()">
    {{ 'UserManagementComponent.inviteUser' | translate }}
  </button>
</div>

<ng-dynamic-http-table
  #userTable
  [crudClass]="userService"
  [displayedColumnsObject]="myColumns"
  [mode]="'table'"
  [showSearch]="false"
  [pageSize]="10"
>
</ng-dynamic-http-table>
